module.exports = __webpack_public_path__ + "img/404.c89a1fc0.svg";